var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgIconHandPowerMeter = function SvgIconHandPowerMeter(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#FFE9A8"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M5.958 12.833H3.667a.917.917 0 0 0-.917.917v4.583c0 .507.41.917.917.917h2.291c.507 0 .917-.41.917-.917V13.75a.917.917 0 0 0-.917-.917M12.146 8.25H9.854a.917.917 0 0 0-.916.917v9.166c0 .507.41.917.916.917h2.292c.506 0 .916-.41.916-.917V9.167a.917.917 0 0 0-.916-.917M18.333 2.75h-2.291a.917.917 0 0 0-.917.917v14.666c0 .507.41.917.917.917h2.291c.507 0 .917-.41.917-.917V3.667a.917.917 0 0 0-.917-.917"
  }))));
};
export default SvgIconHandPowerMeter;